import '../css/app.css';

import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import type { DefineComponent } from 'vue';
import { createApp, h } from 'vue';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';
import { initializeTheme } from './composables/useAppearance';
import { initializeSentry } from './utils/sentry/sentry';

import permissionsPlugin from './plugins/permissions';
import { initializeI18n } from './utils/i18next/i18next';
import { initializePinia } from './utils/pinia/pinia';

// Use type augmentation for vite
declare global {
    interface ImportMeta {
        readonly env: Record<string, string>;
        readonly glob: <T>(pattern: string) => Record<string, () => Promise<T>>;
    }
}

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./pages/${name}.vue`, import.meta.glob<DefineComponent>('./pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) });
        initializePinia(app);
        initializeI18n(app, props);
        initializeSentry(app);
        app.use(plugin).use(ZiggyVue).use(permissionsPlugin).mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});

// This will set light / dark mode on page load...
initializeTheme();
